import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import {
  Container, ContainerHeader, QuestionOrder, Title,
} from '../styles';

import {
  MatrixTableContainer,
  TableWrapper,
  TableRow,
  TableCell,
  ResultBox,
} from './styles';
import TableRowColumnDescription from './TableRowColumnDescription';

const MatrixChart = (props) => {
  const {
    title,
    data,
  } = props;

  const {
    label,
    questionOrder,
    options,
    matrixType,
  } = data;

  const rows = _.filter(options, (option) => option.matrixOption === 'row');
  const columns = _.filter(options, (option) => option.matrixOption === 'column');
  const resultMatrix = JSON.parse(data.matrix);
  const titleMatrixType = matrixType === 'single_select' ? `${title} Single Select` : `${title} Multiple Select`;

  return (
    <Container>
      <ContainerHeader>
        <QuestionOrder>{`Question ${questionOrder + 1}`}</QuestionOrder>
        <Title>{`${label} (${titleMatrixType})`}</Title>
      </ContainerHeader>
      <MatrixTableContainer data-matrix-chart>
        <TableWrapper>
          <TableRow>
            <TableCell />
            {columns.map((column) => (
              <TableRowColumnDescription key={column.label} text={column.label} />
            ))}
          </TableRow>
          {rows.map((row, indexRow) => (
            <TableRow>
              <TableRowColumnDescription text={row.label} />
              {columns.map((column, indexColumn) => (
                <TableCell key={`${row.id}-${column.id}`}>
                  <ResultBox
                    percentage={resultMatrix[row.id][column.id].percentage.toFixed(0)}
                    data-matrix-box={`${indexRow}-${indexColumn}`}
                  >
                    {
                      `${resultMatrix[row.id][column.id].count} (${resultMatrix[row.id][column.id].percentage.toFixed(0)}%)`
                    }
                  </ResultBox>
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableWrapper>
      </MatrixTableContainer>
    </Container>
  );
};

MatrixChart.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.shape({
    label: PropTypes.string,
    questionOrder: PropTypes.number,
    options: PropTypes.arrayOf(PropTypes.shape({})),
    matrixType: PropTypes.string,
    matrix: PropTypes.string,
  }).isRequired,
};

export default MatrixChart;
